import { LayoutContext } from "../contexts/layout.js";
import { extractNavigationCatalog, getLayoutRegionNavigationDirectory } from "../utils/navigation.js";
import { useMemo } from "react";
import { jsx } from "react/jsx-runtime";
// src/providers/layout-context.tsx
const LayoutContextProvider = ({ LinkComponent, currentRoute, isHydrated = true, layoutConfig, children }) => {
	/**
	* Links from all primary navigation groups merged into a single array
	* and ordered by global priority.
	*/
	const primaryNavCatalog = useMemo(() => extractNavigationCatalog(getLayoutRegionNavigationDirectory("header", layoutConfig.navigation.directory)), [layoutConfig.navigation.directory]);
	const contextValue = useMemo(() => ({
		Link: LinkComponent,
		currentRoute,
		isHydrated,
		layoutConfig: {
			...layoutConfig,
			navigation: {
				...layoutConfig.navigation,
				rootRoutePathname: layoutConfig.navigation.rootRoutePathname ?? "/"
			}
		},
		primaryNavCatalog
	}), [
		LinkComponent,
		currentRoute,
		isHydrated,
		layoutConfig,
		primaryNavCatalog
	]);
	return /* @__PURE__ */ jsx(LayoutContext.Provider, {
		value: contextValue,
		children
	});
};
export { LayoutContextProvider };

//# sourceMappingURL=layout-context.js.map